import React from 'react';


import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';



import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';


import Grid from '@mui/material/Grid';


import LoadingButton from 'components/Shared/LoadingButton';
import MyDatePicker from 'components/Shared/MyDatePicker';


const modeRetourLabel = "Mode de retour ";
const modeRetourLabels = [
    "Navette",
    "Ordre d'enlèvement",
    "TNT"
];


export default function PackingListDialog({ open, onCancel, onGenerate, isGeneratingPackingList }) {

    const [nbPalettes, setNbPalettes] = React.useState(0, );
    const [nbColis, setNbColis] = React.useState(0);
    const [nbLongueur, setNbLongueur] = React.useState(0);
    const [modeRetour, setModeRetour] = React.useState('');
    const [dateExpedition, setDateExpedition] = React.useState(new Date());

    const [numero, setNumero] = React.useState('');


    const handleGenerate = () => {

        onGenerate(
            {
                nbPalettes,
                nbColis,
                nbLongueur,
                modeRetour,
                modeRetourLibelle: modeRetourLabels[modeRetour],
                dateExpedition,
                numero
            });
    };

    let validationDisabled = (nbPalettes === 0 && nbColis === 0 && nbLongueur === 0) || modeRetour === '' || (numero === '' && (modeRetour === '1' || modeRetour === '2'));

  return (
      <Dialog open={open} onClose={onCancel} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Génération de la packing list</DialogTitle>
          <DialogContent>
              <DialogContentText>
                  Indiquer les conditions de retour
              </DialogContentText>


              <Grid container spacing={1}>
                  <Grid container item xs={12} spacing={3}>
                      <Grid item xs={4}>
                          <TextField
                              id="nbPalettes"
                              label="Nombre de palettes"
                              type="number"
                              InputLabelProps={{
                                  shrink: true,
                              }}
                              inputProps={{
                                  min: 0,
                              }}
                              onChange={e => setNbPalettes(e.target.value)}
                              disabled={isGeneratingPackingList}
                          />
                      </Grid>
                      <Grid item xs={4}>
                          <TextField
                              id="nbColis"
                              label="Nombre de colis"
                              type="number"
                              InputLabelProps={{
                                  shrink: true,
                              }}
                              inputProps={{
                                  min: 0,
                              }}
                              onChange={e => setNbColis(e.target.value)}
                              disabled={isGeneratingPackingList}
                          />
                      </Grid>
                      <Grid item xs={4}>
                          <TextField
                              id="nbLongueur"
                              label="Nombre de longueur"
                              type="number"
                              InputLabelProps={{
                                  shrink: true,
                              }}
                              inputProps={{
                                  min: 0,
                              }}
                              onChange={e => setNbLongueur(e.target.value)}
                              disabled={isGeneratingPackingList}
                          />
                      </Grid>
                  </Grid>
                  <Grid item xs={12}>
                      <FormControl component="fieldset">
                          <FormLabel component="legend">{modeRetourLabel}</FormLabel>
                          <RadioGroup aria-label="modeRetour" name="modeRetour" value={modeRetour} onChange={e => setModeRetour(e.target.value)} >
                              {modeRetourLabels.map((reponse, index) => (
                                  <FormControlLabel key={index} value={index.toString()} control={<Radio />} label={reponse} disabled={isGeneratingPackingList}/>
                              ))}
                          </RadioGroup>
                      </FormControl>
                  </Grid>
                  <Grid item xs={12}>

                      {(modeRetour === '1' || modeRetour === '2') &&
                          <TextField
                              id="numero"
                              label={modeRetour === '1' ? "Numéro d'ordre d'enlèvement" : "Numéro de BT"}
                              value={numero}
                              onChange={e => setNumero(e.target.value)}
                              margin="normal"
                              fullWidth
                              disabled={isGeneratingPackingList}
                          />
                      }


                  </Grid>
                  <Grid item xs={12}>

                      <MyDatePicker
                          label="Date d'expédition"
                          value={dateExpedition}
                          onChange={value => setDateExpedition(value)}
                          disableSunday={true} // Pas possible de sélectionner un dimanche.
                          disabled={isGeneratingPackingList}
                      />

                  </Grid>
              </Grid>




          </DialogContent>
          <DialogActions>
              <Button onClick={onCancel} color="primary" disabled={isGeneratingPackingList}>
                  Annuler
              </Button>
              <LoadingButton
                  disabled={validationDisabled}
                  onClick={handleGenerate}
                  label="Générer"
                  pending={isGeneratingPackingList}
              />
          </DialogActions>
      </Dialog>
  );
}
